type LinkAddress = {postalCode?: string}

/**
 * Link to the public Track & Trace page of an address. The new page only shows a shipment when the link
 * contains the postal code of the address, so every link to an address carries it. Without a domain the link
 * is relative (for buttons in the app). An action (e.g. veiligePlek) opens that option on the page.
 */
export function trackTraceLink(trackTrace: string, address?: LinkAddress, addressIndex?: number, domain?: string, action?: string): string {
    const origin = domain ? `https://${domain}` : ''
    const index = typeof addressIndex === 'number' ? `/${addressIndex}` : ''
    const postalCode = (address?.postalCode || '').replace(/\s+/g, '').toUpperCase()
    const params = [postalCode && `postcode=${encodeURIComponent(postalCode)}`, action && `actie=${encodeURIComponent(action)}`].filter(Boolean).join('&')

    return `${origin}/track&trace/${trackTrace}${index}${params ? `?${params}` : ''}`
}

/** Link to the address the page shows by default for an order: the last address. */
export function orderTrackTraceLink(order: {trackTrace?: string, addresses?: LinkAddress[]}, domain?: string): string {
    const addresses = order.addresses || []
    return trackTraceLink(order.trackTrace || '', addresses[addresses.length - 1], undefined, domain)
}
